import Footer from "../../components/footer";
import Gpa from "../../components/Gpa";
import Nav from "../../components/navbar";

function Home(){
    return(
        <div>
              <Nav/>
                <Gpa/>
                <Footer/>
    
        </div>
    )
}
export default Home
